// פונקציות לניהול צבעים עבור classes

// פלטת 20 צבעים מוגדרים מראש - צבעים מובחנים וברורים
export const COLOR_PALETTE = [
  '#FF6B6B', // אדום
  '#4ECDC4', // כחול-ירקרק
  '#45B7D1', // תכלת
  '#FFA07A', // כתום בהיר
  '#98D8C8', // ירוק מנטה
  '#F7DC6F', // צהוב
  '#BB8FCE', // סגול
  '#85C1E2', // כחול בהיר
  '#F8B88B', // אפרסק
  '#ABEBC6', // ירוק בהיר
  '#F06292', // ורוד
  '#AED6F1', // תכלת בהיר
  '#FFE082', // צהוב בהיר
  '#CE93D8', // סגול בהיר
  '#80CBC4', // טורקיז
  '#FFAB91', // כתום בהיר
  '#C5E1A5', // ירוק ליים
  '#EF9A9A', // אדום בהיר
  '#90CAF9', // כחול פסטל
  '#FFF59D', // צהוב לימון
];

// פונקציה שמייצרת צבע ייחודי לפי אינדקס באמצעות Golden Angle
export const generateDistinctColor = (index: number): string => {
  const goldenAngle = 137.508;
  const hue = (index * goldenAngle) % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

// פונקציה ראשית לקבלת צבע עבור class
export const getClassColor = (classId: number): string => {
  if (classId < COLOR_PALETTE.length) {
    return COLOR_PALETTE[classId];
  }
  return generateDistinctColor(classId);
};

// פונקציה לקבלת צבע עם שקיפות
export const getClassColorWithOpacity = (classId: number, opacity: number = 0.3): string => {
  const color = getClassColor(classId);
  
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  
  if (color.startsWith('hsl')) {
    return color.replace('hsl', 'hsla').replace(')', `, ${opacity})`);
  }
  
  return color;
};
